import { render, staticRenderFns } from "./Todos.vue?vue&type=template&id=6f05941e"
import script from "./Todos.vue?vue&type=script&lang=ts"
export * from "./Todos.vue?vue&type=script&lang=ts"
import style0 from "./Todos.vue?vue&type=style&index=0&id=6f05941e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports